import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../stylesheets/registrationPopup.css";

const GEV_POSTER_URL = "https://drive.google.com/file/d/1jQSP-nOZlkRg193qGrrGVTsuR4UowR-J/view?usp=sharing";
const FORM_PATH = "/2026/registration/form";
const GEV_VIDEO_ID = "BrrasDNNn1Q";

const RegistrationPopup = () => {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const onFormPage = pathname.startsWith(FORM_PATH);

    useEffect(() => {
        if (onFormPage) return;
        let seen = false;
        try { seen = !!localStorage.getItem("sanket-reg-popup"); } catch (e) { /* ignore */ }
        if (!seen) {
            const t = setTimeout(() => setOpen(true), 800);
            return () => clearTimeout(t);
        }
    }, [onFormPage]);

    const close = () => {
        setOpen(false);
        try { localStorage.setItem("sanket-reg-popup", "1"); } catch (e) { /* ignore */ }
    };

    if (!open || onFormPage) return null;

    return (
        <div className="reg-popup-overlay" onClick={close}>
            <div className="reg-popup" onClick={(e) => e.stopPropagation()}>
                <button className="reg-popup-close" onClick={close} aria-label="Close">×</button>

                <p className="reg-popup-tag">SANKET 2026</p>
                <h2>Registration Now Open</h2>
                <p className="reg-popup-date">4th &amp; 5th December 2026 · IIT Bombay, Mumbai</p>

                <div className="reg-popup-deadlines">
                    <p><span>Early Bird Registration:</span> 7 November 2026</p>
                    <p><span>Final Registration Deadline:</span> 10 November 2026</p>
                </div>

                <div className="reg-popup-video">
                    <iframe
                        src={`https://www.youtube-nocookie.com/embed/${GEV_VIDEO_ID}?rel=0`}
                        title="Govardhan Eco Village"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </div>

                <div className="reg-popup-actions">
                    <a
                        href={FORM_PATH}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="reg-popup-btn primary"
                        onClick={close}
                    >
                        Register Now ↗
                    </a>
                    <a
                        href={GEV_POSTER_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="reg-popup-btn secondary"
                        onClick={close}
                    >
                        GEV Visit – 6 Dec ↗
                    </a>
                    <button
                        type="button"
                        className="reg-popup-btn secondary"
                        onClick={() => {
                            close();
                            navigate("/2026/registration");
                            setTimeout(() => {
                                document.getElementById("registration-fees")?.scrollIntoView({ behavior: "smooth" });
                            }, 300);
                        }}
                    >
                        View Fees
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RegistrationPopup;


// import { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import "../stylesheets/registrationPopup.css";

// const GEV_POSTER_URL = "https://drive.google.com/file/d/1jQSP-nOZlkRg193qGrrGVTsuR4UowR-J/view?usp=sharing";
// const FORM_PATH = "/2026/registration/form";

// const RegistrationPopup = () => {
//     const [open, setOpen] = useState(false);
//     const navigate = useNavigate();
//     const { pathname } = useLocation();
//     const onFormPage = pathname.startsWith(FORM_PATH);

//     useEffect(() => {
//         if (onFormPage) return;
//         let seen = false;
//         try { seen = !!localStorage.getItem("sanket-reg-popup"); } catch (e) { /* ignore */ }
//         if (!seen) {
//             const t = setTimeout(() => setOpen(true), 800);
//             return () => clearTimeout(t);
//         }
//     }, [onFormPage]);

//     const close = () => {
//         setOpen(false);
//         try { localStorage.setItem("sanket-reg-popup", "1"); } catch (e) { /* ignore */ }
//     };

//     if (!open || onFormPage) return null;

//     return (
//         <div className="reg-popup-overlay" onClick={close}>
//             <div className="reg-popup" onClick={(e) => e.stopPropagation()}>
//                 <button className="reg-popup-close" onClick={close} aria-label="Close">×</button>

//                 <p className="reg-popup-tag">SANKET 2026</p>
//                 <h2>Registration Now Open</h2>
//                 <p className="reg-popup-date">4th &amp; 5th December 2026 · IIT Bombay, Mumbai</p>

//                 <div className="reg-popup-deadlines">
//                     <p><span>Early Bird Deadline:</span> 7 November 2026</p>
//                     <p><span>Final Registration Deadline:</span> 21 November 2026</p>
//                 </div>

//                 <div className="reg-popup-actions">
//                     <a
//                         href={FORM_PATH}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="reg-popup-btn primary"
//                         onClick={close}
//                     >
//                         Register Now ↗
//                     </a>
//                     <a
//                         href={GEV_POSTER_URL}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="reg-popup-btn secondary"
//                         onClick={close}
//                     >
//                         GEV Visit – 6 Dec ↗
//                     </a>
//                     <button
//                         type="button"
//                         className="reg-popup-btn secondary"
//                         onClick={() => {
//                             close();
//                             navigate("/2026/registration");
//                             setTimeout(() => {
//                                 document.getElementById("registration-fees")?.scrollIntoView({ behavior: "smooth" });
//                             }, 300);
//                         }}
//                     >
//                         View Fees
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default RegistrationPopup;
